import 'jquery'
import 'geocomplete'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueScrollactive from 'vue-scrollactive'
import {ApexOptions} from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import {Promised} from 'vue-promised'
import {attachErrorHandler} from '@sentry/vue'

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome'

import Alert from '@/components/Alert.vue'
import MotionLocations from '@/components/space/MotionLocations.vue'
import DashboardChartIssuesDonut from '@/components/dashboard/DashboardChartIssuesDonut.vue'
import SpaceCaregiverRolesHelpIcon from '@/components/space/SpaceCaregiverRolesHelpIcon.vue'
import SpaceChartMotionTrend from '@/components/space/SpaceChartMotionTrend.vue'
import SpaceChartNightTimeActivity from '@/components/space/SpaceChartNightTimeActivity.vue'
import SpaceChartRoomActivity from '@/components/space/SpaceChartRoomActivity.vue'
import SpaceChartRoomActivityGrouping from '@/components/space/SpaceChartRoomActivityGrouping.vue'
import SpaceChartSensoryData from '@/components/space/SpaceChartSensoryData.vue'
import SpaceDeviceMap from '@/components/space/SpaceDeviceMap.vue'
import SpaceSettingsHelpIcon from '@/components/space/SpaceSettingsHelpIcon.vue'
import SpaceSleepHelpIcon from '@/components/space/SpaceSleepHelpIcon.vue'
import SpaceSubnav from '@/components/space/SpaceSubnav.vue'
import SpaceTagsHelpIcon from '@/components/space/SpaceTagsHelpIcon.vue'
import SpaceTitle from '@/components/space/SpaceTitle.vue'
import SpaceVoiceCaller from '@/components/space/SpaceVoiceCaller.vue'

// Do setup for these other libs in separate files.
import '@/ext/bootstrap-vue'
import '@/ext/fontawesome'

// CSS entry point.
import '@/assets/css/main.scss'

// Global scripts init
import '@/global'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV != 'production'
Vue.config.performance = process.env.NODE_ENV != 'production'

if (window.Sentry) {
  // Setup Vue/Sentry error integration
  // See https://github.com/getsentry/sentry-javascript/issues/1854
  // We set SentryInitOptions in base.tpl since we need all the same settings to re-initialize here.
  const Sentry = window.Sentry
  const options = window.SentryInitOptions || {}

  // https://docs.sentry.io/platforms/javascript/guides/vue/
  // @ts-ignore
  attachErrorHandler(Vue, {
    attachProps: true,
    logErrors: true,
    trackComponents: true,
  })
}

// Components
Vue.component('apexchart', VueApexCharts)
Vue.component('Promised', Promised)

// Custom components
Vue.component('acp-alert', Alert)
Vue.component('acp-motion-locations', MotionLocations)
Vue.component('acp-dashboard-chart-issues-donut', DashboardChartIssuesDonut)
Vue.component('acp-space-caregiver-roles-help-icon', SpaceCaregiverRolesHelpIcon)
Vue.component('acp-space-chart-motion-trend', SpaceChartMotionTrend)
Vue.component('acp-space-chart-night-time-activity', SpaceChartNightTimeActivity)
Vue.component('acp-space-chart-room-activity', SpaceChartRoomActivity)
Vue.component('acp-space-chart-room-activity-grouping', SpaceChartRoomActivityGrouping)
Vue.component('acp-space-chart-sensory-data', SpaceChartSensoryData)
Vue.component('acp-space-device-map', SpaceDeviceMap)
Vue.component('acp-space-settings-help-icon', SpaceSettingsHelpIcon)
Vue.component('acp-space-sleep-help-icon', SpaceSleepHelpIcon)
Vue.component('acp-space-subnav', SpaceSubnav)
Vue.component('acp-space-tags-help-icon', SpaceTagsHelpIcon)
Vue.component('acp-space-title', SpaceTitle)
Vue.component('acp-space-voice-caller', SpaceVoiceCaller)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.use(VueClipboard)
Vue.use(VueScrollactive)

// https://github.com/apexcharts/vue-apexcharts
Vue.use(VueApexCharts)
let ApexDefaultOptions: ApexOptions = {
  chart: {
    width: '100%',
    zoom: {
      enabled: true,
    },
    toolbar: {
      show: false,
    },
    fontFamily: 'Nunito, sans-serif',
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
  },
  colors: ['#42c4d7', '#665eff', '#00E396', '#FEB019', '#FF4560'],
}
window.Apex = ApexDefaultOptions

// https://day.js.org/docs
import dayjs from 'dayjs'
import VueDayjs from 'vue-dayjs'
dayjs.extend(require('dayjs/plugin/localizedFormat'))
dayjs.extend(require('dayjs/plugin/relativeTime'))
dayjs.extend(require('dayjs/plugin/utc'))
dayjs.extend(require('dayjs/plugin/timezone'))
// @ts-ignore
dayjs.tz.setDefault('America/New_York')
Vue.use(VueDayjs, {lang: 'en'})

// Entry points import
import formsEntryPoint from '@/utils/forms'
window.ALOE = window.ALOE || {}
window.ALOE = {
  forms: formsEntryPoint,
}

Vue.filter('title', function (value) {
  // Convert to title case
  return value.toLowerCase().replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase())
})

new Vue({
  el: '#app',
})
